/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getUser, finishOnboarding, fetchLoggedInUser } from 'src/user';
import { sendAccountInvite } from 'src/account';

import { getToken } from '../index.js';

class Invite extends Component {
  state = {
    businessName: '',
    ownerEmail: '',
    ownerFirstName: '',
    ownerLastName: '',
    ownerMobilePhone: '',
  };

  async componentDidMount() {
    const { token, fetchLoggedInUser } = this.props;

    if (!token.isEmpty()) {
      await fetchLoggedInUser();
    }
  }

  handleInviteAccount = async () => {
    const { sendAccountInvite, user } = this.props;
    const {
      businessName,
      ownerEmail,
      ownerFirstName,
      ownerLastName,
      ownerMobilePhone,
    } = this.state;

    await sendAccountInvite({
      financialInstitutionId: 1,
      businessName,
      ownerEmail,
      ownerFirstName,
      ownerLastName,
      ownerMobilePhone,
    });

    this.setState({
      businessName: '',
      ownerEmail: '',
      ownerFirstName: '',
      ownerLastName: '',
      ownerMobilePhone: '',
    });
  };

  render() {
    const {
      businessName,
      ownerEmail,
      ownerFirstName,
      ownerLastName,
      ownerMobilePhone,
    } = this.state;

    return (
      <div style={{ padding: '25px' }}>
        <b>Send Invite</b>
        <br />
        <br />
        Business name:
        <br />
        <input
          style={{ width: '300px', marginBottom: '20px' }}
          value={businessName}
          onChange={e => this.setState({ businessName: e.target.value })}
        />
        <br />
        Owner email:
        <br />
        <input
          style={{ width: '300px', marginBottom: '20px' }}
          value={ownerEmail}
          onChange={e => this.setState({ ownerEmail: e.target.value })}
        />
        <br />
        Owner first name:
        <br />
        <input
          style={{ width: '300px', marginBottom: '20px' }}
          value={ownerFirstName}
          onChange={e => this.setState({ ownerFirstName: e.target.value })}
        />
        <br />
        Owner last name:
        <br />
        <input
          style={{ width: '300px', marginBottom: '20px' }}
          value={ownerLastName}
          onChange={e => this.setState({ ownerLastName: e.target.value })}
        />
        <br />
        Owner mobile phone:
        <br />
        <input
          style={{ width: '300px', marginBottom: '20px' }}
          value={ownerMobilePhone}
          onChange={e => this.setState({ ownerMobilePhone: e.target.value })}
        />
        <br />
        <br />
        <button onClick={this.handleInviteAccount}>Send account invite</button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  token: getToken(state),
  user: getUser(state),
});

export const InvitePage = connect(
  mapStateToProps,
  {
    fetchLoggedInUser,
    sendAccountInvite,
  }
)(Invite);
